module.exports = __webpack_public_path__ + "static/media/25.bf1f26ee.png";